module.exports = __webpack_public_path__ + "mobile/img/img_home_list_banner2.a67b6062.png";